import * as os from 'node:os';
import { getCliLocation } from '../utils';

export function additionalLogDetails() {
    return {
        cliLocation: getCliLocation(),
        userInfo: os.userInfo(),
        platform: os.platform(),
        release: os.release(),
    };
}
